import { graphql } from "react-relay";

export const load_enrolments = graphql`
  query LoadEnrolmentsQuery(
    $searchTerm: String
    $orderBy: String
    $schoolId: String
    $pupil: String
    $lessonStage: String
    $schoolYear: String
    $instrument: String
    $status: String
    $excludeStatus: String
    $first: Int!
    $after: String
  ) {
    ...LoadEnrolments_query_enrolments
      @arguments(
        orderBy: $orderBy
        searchTerm: $searchTerm
        pupil: $pupil
        schoolId: $schoolId
        lessonStage: $lessonStage
        schoolYear: $schoolYear
        instrument: $instrument
        status: $status
        excludeStatus: $excludeStatus
        first: $first
        after: $after
      )
  }
`;

export const load_enrolments_pagination = graphql`
  fragment LoadEnrolments_query_enrolments on Query
  @argumentDefinitions(
    searchTerm: { type: "String" }
    orderBy: { type: "String" }
    schoolId: { type: "String" }
    pupil: { type: "String" }
    lessonStage: { type: "String" }
    schoolYear: { type: "String" }
    instrument: { type: "String" }
    status: { type: "String" }
    excludeStatus: { type: "String" }
    first: { type: "Int!" }
    after: { type: "String" }
  )
  @refetchable(queryName: "LoadEnrolmentsPaginationQuery") {
    enrolments(
      orderBy: $orderBy
      searchTerm: $searchTerm
      pupil: $pupil
      schoolId: $schoolId
      lessonStage: $lessonStage
      schoolYear: $schoolYear
      instrument: $instrument
      status: $status
      excludeStatus: $excludeStatus
      first: $first
      after: $after
    ) @connection(key: "LoadEnrolments_query_enrolments") {
      __id
      edges {
        node {
          id
          school {
            id
            name
            archived
          }
          status
          lastOfferedTimestamp
          pupilFirstName
          pupilLastName
          schoolYear
          schoolClass
          instrument
          lessonStage
          parentName
          parentEmail
          parentPhoneNumber
          hasInvalidParentPhoneNumber
          pupilNotes
          adminNotes
          positionInWaitingList
          potentialDuplicates {
            edges {
              node {
                id
                pupilFirstName
                pupilLastName
              }
            }
          }
          potentialDuplicatePupils {
            edges {
              node {
                id
                accountNumber
              }
            }
          }
        }
      }
    }
  }
`;
